import { useCallback, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { api } from "lib/api";
import { apiURl } from "store/actions";
import { LogoutUser } from "store/reducer";

export function useLogout({ redirectTo = "/login" } = {}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const inFlightRef = useRef(false);

  const logout = useCallback(async () => {
    if (inFlightRef.current) return;
    inFlightRef.current = true;
    setIsLoggingOut(true);

    try {
      await api.post(apiURl.logout);
    } catch {
      // Still clear local session if the server session is already gone.
    } finally {
      dispatch(LogoutUser());
      inFlightRef.current = false;
      setIsLoggingOut(false);
      navigate(redirectTo, { replace: true });
    }
  }, [dispatch, navigate, redirectTo]);

  return { logout, isLoggingOut };
}

export default useLogout;
